import type { ReactNode } from 'react';
import { useTheme } from '../../hooks/useTheme';
import { Button } from '../../components/primitives';
import { Icon } from '../../components/Icon';

/** Marca OXXEAN, como en el original: OX·X en teal·EAN. */
export function OxxeanLogo(): JSX.Element {
  return (
    <span className="auth__logo">
      OX<span>X</span>EAN
    </span>
  );
}

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: ReactNode;
  children: ReactNode;
}): JSX.Element {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="auth">
      <aside className="auth__aside">
        <div>
          <OxxeanLogo />
          <p className="auth__name">People Analytics OXXEAN 360</p>
        </div>

        <div>
          <p className="auth__claim">Indicadores de personas con el estado del dato a la vista.</p>
          <ul className="auth__points" style={{ marginTop: 18 }}>
            <li>
              <Icon name="check" size={15} />
              Un número nunca se muestra sin decir de dónde viene.
            </li>
            <li>
              <Icon name="check" size={15} />
              «Sin registros» no es 0 % ni 100 %: es sin registros.
            </li>
            <li>
              <Icon name="check" size={15} />
              Consolidación de BUK y BUK Asistencia, sólo lectura.
            </li>
          </ul>
        </div>

        <p className="auth__legal">
          Plataforma interna de OXXEAN. El acceso queda registrado en la auditoría del sistema. La
          información contiene datos de carácter personal: su uso está limitado a las funciones
          autorizadas de Gestión de Personas.
        </p>
      </aside>

      <main className="auth__main">
        <div className="auth__card">
          <div className="auth__mobile-brand">
            <OxxeanLogo />
            <p className="auth__name">People Analytics OXXEAN 360</p>
          </div>

          <div className="card">
            <div className="inline" style={{ justifyContent: 'space-between' }}>
              <h1>{title}</h1>
              <Button
                variant="icon"
                onClick={toggleTheme}
                aria-label={theme === 'light' ? 'Activar modo oscuro' : 'Activar modo claro'}
              >
                <Icon name={theme === 'light' ? 'moon' : 'sun'} size={16} />
              </Button>
            </div>
            <p className="auth__sub">{subtitle}</p>
            {children}
          </div>

          <p className="tiny muted" style={{ marginTop: 14, textAlign: 'center' }}>
            Uso interno exclusivo · OXXEAN · Gestión de Personas
          </p>
        </div>
      </main>
    </div>
  );
}
